import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';

const pushNotificationPopup = createNamespacer("PUSH_NOTIFICATION")

const initialState = {
    pushNotificationPopup: {
        loadId: "",
        bolId: "",
        foremans: '',
        owners: '',
    },
}

export const pushNotificationReducer = createReducer(initialState.pushNotificationPopup, {
    [pushNotificationPopup("SET_BOL_ID")]: (state, action) => {
        return {
            ...state,
            bolId: action.payload.value,
        }
    },
    [pushNotificationPopup("SET_LOAD_ID")]: (state, action) => {
        return {
            ...state,
            loadId: action.payload.value,
        }
    },
    [pushNotificationPopup("SET_OWNERS")]: (state, action) => {
        return {
            ...state,
            owners: action.payload.value,
        }
    },
    [pushNotificationPopup("SET_FOREMANS")]: (state, action) => {
        return {
            ...state,
            foremans: action.payload.value,
        }
    },
});

